import React from 'react';
import { getUniqueTicketNames } from '../utils/helpers';

interface SearchFiltersProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  attendeeSearchTerm: string;
  setAttendeeSearchTerm: (term: string) => void;
  ticketNameFilter: string;
  setTicketNameFilter: (filter: string) => void;
  currentFilter: string;
  setCurrentFilter: (filter: string) => void;
  allTables: any[];
}

export const SearchFilters: React.FC<SearchFiltersProps> = ({
  searchTerm,
  setSearchTerm,
  attendeeSearchTerm,
  setAttendeeSearchTerm,
  ticketNameFilter,
  setTicketNameFilter,
  currentFilter,
  setCurrentFilter,
  allTables
}) => {
  return (
    <div style={{ 
      padding: '16px 20px', 
      backgroundColor: '#f8fafc', 
      borderBottom: '1px solid #e5e7eb' 
    }}>
      {/* Search Controls */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ marginBottom: '8px', fontWeight: 500, color: '#4b5563' }}>Search</div>
        <input
          type="search"
          placeholder="Search by table number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #e5e7eb',
            borderRadius: '6px',
            fontSize: '0.95rem',
            outline: 'none',
            marginBottom: '8px'
          }}
        />
        <input
          type="search"
          placeholder="Search by attendee name..."
          value={attendeeSearchTerm}
          onChange={(e) => setAttendeeSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #e5e7eb',
            borderRadius: '6px',
            fontSize: '0.95rem',
            outline: 'none',
            marginBottom: '8px'
          }}
        />
        
        {/* Ticket Name Filter */}
        <div style={{ marginBottom: '8px' }}>
          <div style={{ marginBottom: '4px', fontWeight: 500, color: '#4b5563', fontSize: '0.875rem' }}>Filter by Ticket</div>
          <select
            value={ticketNameFilter}
            onChange={(e) => setTicketNameFilter(e.target.value)}
            style={{
              width: '100%',
              padding: '8px 12px',
              border: '1px solid #e5e7eb',
              borderRadius: '6px',
              fontSize: '0.95rem',
              outline: 'none',
              backgroundColor: 'white',
              cursor: 'pointer'
            }}
          >
            <option value="all">All Tickets</option>
            {getUniqueTicketNames(allTables).map(ticketName => (
              <option key={ticketName} value={ticketName}>{ticketName}</option>
            ))}
          </select>
        </div>
      </div>
      
      {/* Filter Controls */}
      <div>
        <div style={{ marginBottom: '8px', fontWeight: 500, color: '#4b5563' }}>Filter by Status</div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {[
            { id: 'all', label: 'All Tables' },
            { id: 'checked-in', label: 'All Checked In' },
            { id: 'not-checked-in', label: 'None Checked In' },
            { id: 'partially-checked-in', label: 'Partially Checked In' },
            { id: 'empty', label: 'Has Empty Seats' },
            { id: 'full', label: 'Fully Occupied' }
          ].map(filter => (
            <button
              key={filter.id}
              onClick={() => setCurrentFilter(filter.id)}
              style={{
                padding: '6px 12px',
                border: '1px solid #e5e7eb',
                borderRadius: '20px',
                fontSize: '0.875rem',
                cursor: 'pointer',
                transition: 'all 0.2s',
                background: currentFilter === filter.id ? '#3b82f6' : 'white',
                color: currentFilter === filter.id ? 'white' : '#374151'
              }}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}; 